import { AuthenticationService } from './authentication.service';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpErrorFilter implements HttpInterceptor {

  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        console.log("Token expired. Attempting refresh...");
        if (error.status === 401 && !request.url.includes('auth/authenticate')) {
          return this.handle401Error(request, next);
        }
        return throwError(error);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

    if (request.url.includes('auth/refreshtoken')) {
      this.isRefreshingToken = false;
      return of(<any>this.authenticationService.logout());
    }
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      this.tokenSubject.next(null);

      return this.authenticationService.refreshToken().pipe(switchMap(token => {
        if (token) {
          console.log("refresh token successful");
          this.tokenSubject.next(token);
          return next.handle(request);
        }
        console.log("refresh token failed");

        return of(<any>this.authenticationService.logout());
      }),
        catchError(err => {
          this.authenticationService.logout();
          return throwError(err.error);
        }),
        finalize(() => {
          this.isRefreshingToken = false;
        }));
    } else {
      this.isRefreshingToken = false;

      return this.tokenSubject
        .pipe(filter(token => token != null),
          take(1),
          switchMap(token => {
            return next.handle(request);
          }));
    }
  }
}


@Injectable()
export class HttpFilter implements HttpInterceptor {

  //private apiUrl = environment.apiUrl;

  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addAuthentication(request));
  }

  private addAuthentication(request: HttpRequest<any>): HttpRequest<any> {

    if (!request.url.includes('/auth/')) {
      let currentUser = this.authenticationService.currentAppUserValue;

      if (currentUser && currentUser.token) {
        const token = currentUser.token;
        //const token = localStorage.getItem('access.token');
        if (token) {
          request = request.clone({
            setHeaders: { Authorization: 'Bearer ' + token }
          });
        }
      }
    }
    return request.clone({ url: `${request.url}` });
    //return request.clone({ url: `${this.apiUrl}${request.url}` });

  }

}
//@Injectable()
//export class JwtInterceptor implements HttpInterceptor {
//  constructor(private authenticationService: AuthenticationService) { }

//  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//    // add authorization header with jwt token if available
//    let currentUser = this.authenticationService.currentAppUserValue;
//    if (currentUser && currentUser.token) {
//      request = request.clone({
//        setHeaders: {
//          Authorization: 'Bearer ' + currentUser.token
//        }
//      });
//    }

//    return next.handle(request);
//  }
//}



//@Injectable()
//export class ErrorInterceptor implements HttpInterceptor {
//  constructor(private authenticationService: AuthenticationService) { }

//  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//    return next.handle(request).pipe(
//      catchError(err => {
//        if ([401, 403].indexOf(err.status) !== -1) {
//          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
//          this.authenticationService.logout();
//          location.reload(true);
//        }
//         const error = err.error.message || err.statusText;
//            return throwError(error);
//      })
//    );
//  }
//}
